/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line func-names
(function (angular) {
  angular.module("app").controller("homeController", homeController);

  homeController.$inject = [
    "$cookies",
    "modalService",
    "alerts",
    "eventsPayload",
    "EventsApi",
    "UsersApi",
    "thisSiteSettings",
    "thisUser",
    "welcomed",
    "Polls",
    "Events",
    "Promotions",
    "Resources",
    "News",
    "Surveys",
  ];

  function homeController(
    $cookies,
    modalService,
    alerts,
    eventsPayload,
    EventsApi,
    UsersApi,
    thisSiteSettings,
    thisUser,
    welcomed,
    Polls,
    Events,
    Promotions,
    Resources,
    News,
    Surveys,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    // properties
    vm.isLoading = true;
    vm.events = [];
    vm.viewEvents = [];

    /**
     * Shows the create poll modal
     * @return {void}
     */
    function createPoll(): void {
      Polls.managePoll();
    }

    /**
     * Shows the create survey modal
     * @return {void}
     */
    function createSurvey(): void {
      Surveys.manageSurvey();
    }

    /**
     * Creates an event modal
     * @return {void}
     */
    function createEvent(): void {
      Events.create();
    }

    /**
     * Shows the create promotion modal
     * @return {void}
     */
    function createPromotion(): void {
      Promotions.managePromotion();
    }

    /**
     * Shows the create resource modal
     * @return {void}
     */
    function createResource(): void {
      Resources.manageResource();
    }

    /**
     * Shows the create resource modal
     * @return {void}
     */
    function createPost(): void {
      News.manageNews();
    }

    vm.createPoll = createPoll;
    vm.createSurvey = createSurvey;
    vm.createEvent = createEvent;
    vm.createPromotion = createPromotion;
    vm.createResource = createResource;
    vm.createPost = createPost;

    const welcomeMessageSeen = $cookies.get("welcome_message_seen");

    // if user has not been welcomed and a welcome message is set.
    if (!welcomed && thisSiteSettings.site_welcome_msg && !welcomeMessageSeen) {
      modalService.open({
        templateUrl: "modals/welcome.html",
        controller: "confirmController",
        controllerAs: "vm",
        windowClass: "confirm",
        resolve: {
          message() {
            return thisSiteSettings.site_welcome_msg;
          },
        },
      });

      // store cookie so this wecome message isn't shown again
      $cookies.put("welcome_message_seen", true);
    }

    const gdprSettings =
      thisSiteSettings.gdpr_settings && thisSiteSettings.gdpr_settings.signup;
    if (thisUser) {
      if (
        window
          .moment(thisUser.agreed_at || 0)
          .isBefore(window.moment(gdprSettings.modified))
      ) {
        modalService
          .open({
            animation: true,
            templateUrl: "modals/gdpr-modal.html",
            controller: "gdprModal",
            controllerAs: "vm",
            resolve: {
              shouldDeleteUserIfRejected() {
                return true;
              },
            },
          })
          .result.then((result) => {
            UsersApi.update(
              {
                id: thisUser.id,
              },
              {
                ...thisUser,
                agreed_to: result.signup.content,
                agreed_at: window.moment().format("YYYY-MM-DD HH:mm:ss"),
                agreed_on: "login",
              },
              () => {
                alerts.emit({
                  theme: "success",
                  title: "User settings updated",
                });
              },
            );
          });
      }
    }

    // Convert events from page payload to resource models
    angular.forEach(eventsPayload.data, (event) => {
      vm.events.push(new EventsApi(event).transform());
    });

    // Slice in to groups of two.
    for (let i = 0; i < vm.events.length; i += 2) {
      vm.viewEvents.push(vm.events.slice(i, i + 2));
    }

    vm.isLoading = false;
  }
})(angular);
